export default __webpack_public_path__ + "static/media/moderator-history-changes-active.0b9affbf.svg";